<template>
  <section>
    <div class="row">
      <div class="col-xs-12">
        <h3>{{ title }}</h3>
      </div>
    </div>
    <div class="row" v-if="carregando">
      <div class="col-xs-12 font-lg">
        <font-awesome-icon :icon="'spinner'" spin />
      </div>
    </div>
    <div class="row">
      <div v-for="(item, index) in items" :key="`proc-${item[chave]}-${index}`">
        <div class="col-xs-12 fields">
          <h4>{{ item[chave] }}</h4>
          <div class="font-lg margem-bottom">
            <div>
              <!-- <label>Posição:</label>
              <span>{{ item.posicao }}</span>
              - -->
              <label>Gravidade:</label>
              <span :class="['gravidade', getGravidadeClass(item.gravidade)]">{{
                item.gravidade
              }}</span>
            </div>
            <div>
              <label>Data da Solicitação:</label>
              <span>{{
                formatTo2DigitsDate(new Date(item.dtsolicitacao))
              }}</span>
            </div>
            <!-- <div>
              <label>Tempo médio de agendamento (dias):</label>
              <span>{{ item.media_espera }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!carregando && !items.length">
      <div class="col-xs-12">
        <p class="font-lg">Nenhum item encontrado</p>
      </div>
    </div>
  </section>
</template>

<script>
import { getGravidadeClass } from './datatableFields'
import { formatTo2DigitsDate } from '../../utils'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    chave: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => [
        {
          posicao: 0,
          gravidade: 'Normal',
          dtsolicitacao: null,
          media_espera: 0
        }
      ]
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getGravidadeClass,
    formatTo2DigitsDate
  }
}
</script>

<style scoped src="./datatable.css"></style>

<style scoped>
.fields label,
span .destaque {
  font-weight: 600;
}
span.gravidade {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/CardFilaEspera.vue